import { _mock } from './_mock';

// ----------------------------------------------------------------------

export const USER_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'pending', label: 'Pending' },
  { value: 'banned', label: 'Banned' },
  { value: 'rejected', label: 'Rejected' },
];

export const _userAbout = {
  id: _mock.id(1),
  role: _mock.role(1),
  email: _mock.email(1),
  school: _mock.companyNames(2),
  company: _mock.companyNames(1),
  country: _mock.countryNames(2),
  coverUrl: _mock.image.cover(3),
  totalFollowers: _mock.number.nativeL(1),
  totalFollowing: _mock.number.nativeL(2),
  quote:
    'Tart I love sugar plum I love oat cake. Sweet roll caramels I love jujubes. Topping cake wafer..',
  socialLinks: {
    facebook: `https://www.facebook.com/caitlyn.kerluke`,
    instagram: `https://www.instagram.com/caitlyn.kerluke`,
    linkedin: `https://www.linkedin.com/in/caitlyn.kerluke`,
    twitter: `https://www.twitter.com/caitlyn.kerluke`,
  },
};

export const _userFollowers = [...Array(18)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.fullName(index),
  country: _mock.countryNames(index),
  avatarUrl: _mock.image.avatar(index),
}));

export const _userFriends = [...Array(18)].map((_, index) => ({
  id: _mock.id(index),
  role: _mock.role(index),
  name: _mock.fullName(index),
  avatarUrl: _mock.image.avatar(index),
}));

export const _userGallery = [...Array(12)].map((_, index) => ({
  id: _mock.id(index),
  postedAt: _mock.time(index),
  title: _mock.postTitle(index),
  imageUrl: _mock.image.cover(index),
}));

export const _gymVideos = [...Array(12)].map((_, index) => ({
  id: _mock.id(index),
  postedAt: _mock.time(index),
  title: _mock.postTitle(index),
  imageUrl: _mock.image.cover(index),
  videoUrl: _mock?.video[index] || null,
  owner: {
    id: _mock.id(index),
    name: _mock.fullName(index),
    avatar: _mock.image.avatar(index),
  },
}));

export const _userFeeds = [...Array(5)].map((_, index) => ({
  id: _mock.id(index),
  createdAt: _mock.time(index),
  media: _mock.image.travel(index + 1),
  message: _mock.sentence(index),
  personLikes: [...Array(20)].map((__, personIndex) => ({
    name: _mock.fullName(personIndex),
    avatarUrl: _mock.image.avatar(personIndex + 2),
  })),
  comments: (index === 2 && []) || [
    {
      id: _mock.id(7),
      author: {
        id: _mock.id(8),
        avatarUrl: _mock.image.avatar(index + 5),
        name: _mock.fullName(index + 5),
      },
      createdAt: _mock.time(2),
      message: 'Praesent venenatis metus at',
    },
    {
      id: _mock.id(9),
      author: {
        id: _mock.id(10),
        avatarUrl: _mock.image.avatar(index + 6),
        name: _mock.fullName(index + 6),
      },
      createdAt: _mock.time(3),
      message:
        'Etiam rhoncus. Nullam vel sem. Pellentesque libero tortor, tincidunt et, tincidunt eget, semper nec, quam. Sed lectus.',
    },
  ],
  video: (index === 3 && _mock.video[0]) || _mock.video[1],
  is_video: ((index === 3 || index === 4) && true) || false,
}));

export const _userCards = [...Array(21)].map((_, index) => ({
  id: _mock.id(index),
  role: _mock.role(index),
  name: _mock.fullName(index),
  coverUrl: _mock.image.cover(index),
  avatarUrl: _mock.image.avatar(index),
  totalFollowers: _mock.number.nativeL(index),
  totalPosts: _mock.number.nativeL(index + 2),
  totalFollowing: _mock.number.nativeL(index + 1),
}));

export const _userPayment = [...Array(3)].map((_, index) => ({
  id: _mock.id(index),
  cardNumber: ['**** **** **** 1234', '**** **** **** 5678', '**** **** **** 7878'][index],
  cardType: ['mastercard', 'visa', 'visa'][index],
  primary: index === 1,
}));

export const _userAddressBook = [...Array(4)].map((_, index) => ({
  id: _mock.id(index),
  primary: index === 0,
  name: _mock.fullName(index),
  phoneNumber: _mock.phoneNumber(index),
  fullAddress: _mock.fullAddress(index),
  addressType: (index === 0 && 'Home') || 'Office',
}));

export const _userInvoices = [...Array(10)].map((_, index) => ({
  id: _mock.id(index),
  invoiceNumber: `INV-199${index}`,
  createdAt: _mock.time(index),
  price: _mock.number.price(index),
}));

export const _userPlans = [
  { subscription: 'basic', price: 0, primary: false },
  { subscription: 'starter', price: 4.99, primary: true },
  { subscription: 'premium', price: 9.99, primary: false },
];

export const _userList = [...Array(20)].map((_, index) => ({
  id: _mock.id(index),
  zipCode: '85807',
  state: 'Virginia',
  city: 'Rancho Cordova',
  role: _mock.role(index),
  email: _mock.email(index),
  address: '908 Jack Locks',
  name: _mock.fullName(index),
  isVerified: _mock.boolean(index),
  company: _mock.companyNames(index),
  country: _mock.countryNames(index),
  avatarUrl: _mock.image.avatar(index),
  phoneNumber: _mock.phoneNumber(index),
  status:
    (index % 2 && 'pending') || (index % 3 && 'banned') || (index % 4 && 'rejected') || 'active',
}));

export const _gymList = [
  {
    id: 12,
    gym_name: 'Get Smart Fit Gym',
    email: 'getsmart@yopmail.com',
    contact_no: '+17183823356',
    country: null,
    city: null,
    about_me:
      'At Fit Smart, we are committed to helping you achieve your fitness goals through personalized training and top-tier facilities. Our certified trainers and variety of classes cater to all fitness levels, ensuring a supportive environment for everyone.',
    location: '2084 Homecrest Ave, USA',
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/AbMhg3PlgWwmfOzXvtK6.jpg',
    owner: {
      id: 13,
      name: 'aesthetic allure',
      first_name: 'aesthetic',
      last_name: 'allure',
      email: 'tonychris1@yopmail.com',
      email_verified_at: '2024-10-11T07:58:42.000000Z',
      contact_no: '+17183823334',
      country: null,
      city: null,
      about_me:
        'I’m Tony Chris, a passionate fitness coach with over [X years] of experience in strength training, cardio, and wellness. My goal is to help you unlock your full potential through customized workout plans that suit your needs and lifestyle.',
      location: '2084 Homecrest Ave',
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/ZckBFOD3Ulkc8WiQIhkU.jpg',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/nuwpqIM9Kqb7oSqJ22vi.jpg',
      user_social_links: [
        {
          id: 77,
          entity_id: 13,
          name: 'Facebook',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T07:54:57.000000Z',
          updated_at: '2024-10-11T07:54:57.000000Z',
        },
        {
          id: 78,
          entity_id: 13,
          name: 'Instagram',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T07:54:57.000000Z',
          updated_at: '2024-10-11T07:54:57.000000Z',
        },
        {
          id: 79,
          entity_id: 13,
          name: 'LinkedIn',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T07:54:57.000000Z',
          updated_at: '2024-10-11T07:54:57.000000Z',
        },
        {
          id: 80,
          entity_id: 13,
          name: 'Twitter',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T07:54:57.000000Z',
          updated_at: '2024-10-11T07:54:57.000000Z',
        },
      ],
      status: 'active',
      deleted_at: null,
      created_at: '2024-10-11T07:42:20.000000Z',
      updated_at: '2024-10-11T08:17:00.000000Z',
    },
    offering_gym_services: [
      {
        id: 1,
        name: 'Personal Training',
        status: 'active',
        created_at: '2024-10-09T01:36:04.000000Z',
        updated_at: '2024-10-09T01:36:04.000000Z',
      },
      {
        id: 6,
        name: 'Nutrition Counseling',
        status: 'active',
        created_at: '2024-10-09T01:36:40.000000Z',
        updated_at: '2024-10-09T01:36:40.000000Z',
      },
      {
        id: 7,
        name: 'Spa Services',
        status: 'active',
        created_at: '2024-10-09T01:36:41.000000Z',
        updated_at: '2024-10-09T01:36:41.000000Z',
      },
      {
        id: 8,
        name: 'Swimming Pools',
        status: 'active',
        created_at: '2024-10-09T01:36:47.000000Z',
        updated_at: '2024-10-09T01:36:47.000000Z',
      },
    ],
    user_social_links: [
      {
        id: 113,
        entity_id: 12,
        name: 'Facebook',
        link: 'https://www.facebook.com/fitsmartgym',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T10:02:21.000000Z',
        updated_at: '2024-10-11T10:02:21.000000Z',
      },
      {
        id: 114,
        entity_id: 12,
        name: 'Instagram',
        link: 'https://www.instagram.com/fitsmartgym',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T10:02:21.000000Z',
        updated_at: '2024-10-11T10:02:21.000000Z',
      },
      {
        id: 115,
        entity_id: 12,
        name: 'LinkedIn',
        link: 'https://www.linkedin.com/fitsmartgym',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T10:02:21.000000Z',
        updated_at: '2024-10-11T10:02:21.000000Z',
      },
      {
        id: 116,
        entity_id: 12,
        name: 'Twitter',
        link: 'https://www.x.com/fitsmartgym',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T10:02:21.000000Z',
        updated_at: '2024-10-11T10:02:21.000000Z',
      },
    ],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-11T07:42:20.000000Z',
    updated_at: '2024-10-11T10:02:20.000000Z',
  },
  {
    id: 11,
    gym_name: 'aesthetic allure',
    email: 'aestheticallure60@gmail.com',
    contact_no: '+17183823333',
    country: null,
    city: null,
    about_me:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    location: '2084 Homecrest Ave',
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/Sm2Ym6IaxVScGnedlWQs.jpg',
    owner: {
      id: 12,
      name: 'aesthetic allure',
      first_name: 'aesthetic',
      last_name: 'allure',
      email: 'floorwarehouse215@gmail.com',
      email_verified_at: '2024-10-11T07:32:29.000000Z',
      contact_no: '+17183823333',
      country: null,
      city: null,
      about_me:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      location: '2084 Homecrest Ave',
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/GY7VlaaVso9o3YtICZgC.jpg',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/V0ObGipzdYadnYaikqVe.jpg',
      user_social_links: [
        {
          id: 69,
          entity_id: 12,
          name: 'Facebook',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T07:30:29.000000Z',
          updated_at: '2024-10-11T07:30:29.000000Z',
        },
        {
          id: 70,
          entity_id: 12,
          name: 'Instagram',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T07:30:29.000000Z',
          updated_at: '2024-10-11T07:30:29.000000Z',
        },
        {
          id: 71,
          entity_id: 12,
          name: 'LinkedIn',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T07:30:29.000000Z',
          updated_at: '2024-10-11T07:30:29.000000Z',
        },
        {
          id: 72,
          entity_id: 12,
          name: 'Twitter',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T07:30:29.000000Z',
          updated_at: '2024-10-11T07:30:29.000000Z',
        },
      ],
      status: 'active',
      deleted_at: null,
      created_at: '2024-10-10T15:00:58.000000Z',
      updated_at: '2024-10-11T07:32:29.000000Z',
    },
    offering_gym_services: [
      {
        id: 1,
        name: 'Personal Training',
        status: 'active',
        created_at: '2024-10-09T01:36:04.000000Z',
        updated_at: '2024-10-09T01:36:04.000000Z',
      },
      {
        id: 2,
        name: 'Group Fitness Classes',
        status: 'active',
        created_at: '2024-10-09T01:36:14.000000Z',
        updated_at: '2024-10-09T01:36:14.000000Z',
      },
    ],
    user_social_links: [
      {
        id: 61,
        entity_id: 11,
        name: 'Facebook',
        link: '',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T07:27:52.000000Z',
        updated_at: '2024-10-11T07:27:52.000000Z',
      },
      {
        id: 62,
        entity_id: 11,
        name: 'Instagram',
        link: '',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T07:27:52.000000Z',
        updated_at: '2024-10-11T07:27:52.000000Z',
      },
      {
        id: 63,
        entity_id: 11,
        name: 'LinkedIn',
        link: '',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T07:27:52.000000Z',
        updated_at: '2024-10-11T07:27:52.000000Z',
      },
      {
        id: 64,
        entity_id: 11,
        name: 'Twitter',
        link: '',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T07:27:52.000000Z',
        updated_at: '2024-10-11T07:27:52.000000Z',
      },
    ],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-10T15:00:58.000000Z',
    updated_at: '2024-10-11T07:23:25.000000Z',
  },
  {
    id: 10,
    gym_name: 'What is Lorem Ipsum?',
    email: null,
    contact_no: null,
    country: null,
    city: null,
    about_me: null,
    location: null,
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
    owner: {
      id: 11,
      name: 'What is Lorem Ipsum? What is Lorem Ipsum?',
      first_name: 'What is Lorem Ipsum?',
      last_name: 'What is Lorem Ipsum?',
      email: 'abc@yopmail.com',
      email_verified_at: null,
      contact_no: null,
      country: null,
      city: null,
      about_me: null,
      location: null,
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
      user_social_links: [],
      status: 'pending',
      deleted_at: null,
      created_at: '2024-10-10T14:36:43.000000Z',
      updated_at: '2024-10-10T14:36:43.000000Z',
    },
    offering_gym_services: [],
    user_social_links: [],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-10T14:36:43.000000Z',
    updated_at: '2024-10-10T14:36:43.000000Z',
  },
  {
    id: 9,
    gym_name: 'Get Fit with Alex',
    email: null,
    contact_no: null,
    country: null,
    city: null,
    about_me: null,
    location: null,
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
    owner: {
      id: 10,
      name: 'alex johnson',
      first_name: 'alex',
      last_name: 'johnson',
      email: 'alexjohnson@yopmail.com',
      email_verified_at: '2024-10-10T14:32:16.000000Z',
      contact_no: null,
      country: null,
      city: null,
      about_me: null,
      location: null,
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
      user_social_links: [],
      status: 'active',
      deleted_at: null,
      created_at: '2024-10-10T14:23:33.000000Z',
      updated_at: '2024-10-10T14:32:16.000000Z',
    },
    offering_gym_services: [],
    user_social_links: [],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-10T14:23:34.000000Z',
    updated_at: '2024-10-10T14:23:34.000000Z',
  },
  {
    id: 8,
    gym_name: 'The Fit Smart Fitness Centre',
    email: null,
    contact_no: null,
    country: null,
    city: null,
    about_me: null,
    location: null,
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
    owner: {
      id: 9,
      name: 'maria golzalez',
      first_name: 'maria',
      last_name: 'golzalez',
      email: 'mariagonzalez@yopmail.com',
      email_verified_at: '2024-10-10T14:22:15.000000Z',
      contact_no: null,
      country: null,
      city: null,
      about_me: null,
      location: null,
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
      user_social_links: [],
      status: 'active',
      deleted_at: null,
      created_at: '2024-10-10T14:22:00.000000Z',
      updated_at: '2024-10-10T14:22:15.000000Z',
    },
    offering_gym_services: [],
    user_social_links: [],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-10T14:22:00.000000Z',
    updated_at: '2024-10-10T14:22:00.000000Z',
  },
  {
    id: 7,
    gym_name: 'The Lean Gym',
    email: null,
    contact_no: null,
    country: null,
    city: null,
    about_me: null,
    location: null,
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
    owner: {
      id: 8,
      name: 'ethan scott',
      first_name: 'ethan',
      last_name: 'scott',
      email: 'ethanscott@yopmail.com',
      email_verified_at: '2024-10-10T14:14:28.000000Z',
      contact_no: null,
      country: null,
      city: null,
      about_me: null,
      location: null,
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
      user_social_links: [],
      status: 'active',
      deleted_at: null,
      created_at: '2024-10-10T14:14:02.000000Z',
      updated_at: '2024-10-10T14:18:21.000000Z',
    },
    offering_gym_services: [],
    user_social_links: [],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-10T14:14:02.000000Z',
    updated_at: '2024-10-10T14:14:02.000000Z',
  },
  {
    id: 5,
    gym_name: 'Fit Center',
    email: null,
    contact_no: null,
    country: null,
    city: null,
    about_me: null,
    location: null,
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
    owner: {
      id: 6,
      name: 'Sohaib Ahmed',
      first_name: 'Sohaib',
      last_name: 'Ahmed',
      email: 'sohaib6030@gmail.com',
      email_verified_at: '2024-10-09T12:41:43.000000Z',
      contact_no: null,
      country: null,
      city: null,
      about_me: null,
      location: null,
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
      user_social_links: [],
      status: 'active',
      deleted_at: null,
      created_at: '2024-10-09T12:40:28.000000Z',
      updated_at: '2024-10-09T12:43:40.000000Z',
    },
    offering_gym_services: [],
    user_social_links: [],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-09T12:40:28.000000Z',
    updated_at: '2024-10-09T12:40:28.000000Z',
  },
  {
    id: 4,
    gym_name: 'FIT BIT MASTER',
    email: 'shakeeb@yopmail.com',
    contact_no: '+923152199247',
    country: null,
    city: null,
    about_me:
      'At Fit Bit, we’re committed to helping you achieve your fitness goals in a supportive and motivating environment. With modern equipment, expert trainers, and a variety of classes, we cater to all fitness levels—from beginners to advanced.',
    location: 'Fl-2, 12, Block 6 Gulshan-e-Iqbal',
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/mkbXTtnjJeFfyhq2z4Pv.jpg',
    owner: {
      id: 5,
      name: 'Muhammad Shakeeb Hussain',
      first_name: 'Muhammad Shakeeb',
      last_name: 'Hussain',
      email: 'shakeeb@yopmail.com',
      email_verified_at: '2024-10-10T15:09:40.000000Z',
      contact_no: '+923152199247',
      country: null,
      city: null,
      about_me: 'Personal Trainer',
      location: 'E-40 Alfalah housing',
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/OC7TfeTb1dDptzJcKYfo.png',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/INRozxhJeSF81BJBTvxg.png',
      user_social_links: [
        {
          id: 85,
          entity_id: 5,
          name: 'Facebook',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T08:27:03.000000Z',
          updated_at: '2024-10-11T08:27:03.000000Z',
        },
        {
          id: 86,
          entity_id: 5,
          name: 'Instagram',
          link: 'http://www.instagram.com',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T08:27:03.000000Z',
          updated_at: '2024-10-11T08:27:03.000000Z',
        },
        {
          id: 87,
          entity_id: 5,
          name: 'LinkedIn',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T08:27:03.000000Z',
          updated_at: '2024-10-11T08:27:03.000000Z',
        },
        {
          id: 88,
          entity_id: 5,
          name: 'Twitter',
          link: '',
          entity_type: 'user',
          status: 'active',
          created_at: '2024-10-11T08:27:03.000000Z',
          updated_at: '2024-10-11T08:27:03.000000Z',
        },
      ],
      status: 'active',
      deleted_at: null,
      created_at: '2024-10-09T10:33:43.000000Z',
      updated_at: '2024-10-11T08:27:03.000000Z',
    },
    offering_gym_services: [
      {
        id: 4,
        name: 'Strength Training Equipment',
        status: 'active',
        created_at: '2024-10-09T01:36:24.000000Z',
        updated_at: '2024-10-09T01:36:24.000000Z',
      },
      {
        id: 5,
        name: 'Functional Training Areas',
        status: 'active',
        created_at: '2024-10-09T01:36:35.000000Z',
        updated_at: '2024-10-09T01:36:35.000000Z',
      },
    ],
    user_social_links: [
      {
        id: 93,
        entity_id: 4,
        name: 'Facebook',
        link: 'https://www.fb.com',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T09:57:44.000000Z',
        updated_at: '2024-10-11T09:57:44.000000Z',
      },
      {
        id: 94,
        entity_id: 4,
        name: 'Instagram',
        link: 'https://www.instagram.com',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T09:57:44.000000Z',
        updated_at: '2024-10-11T09:57:44.000000Z',
      },
      {
        id: 95,
        entity_id: 4,
        name: 'LinkedIn',
        link: 'https://www.linkedin.com',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T09:57:44.000000Z',
        updated_at: '2024-10-11T09:57:44.000000Z',
      },
      {
        id: 96,
        entity_id: 4,
        name: 'Twitter',
        link: 'https://www.x.com',
        entity_type: 'gym',
        status: 'active',
        created_at: '2024-10-11T09:57:44.000000Z',
        updated_at: '2024-10-11T09:57:44.000000Z',
      },
    ],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-09T10:33:43.000000Z',
    updated_at: '2024-10-11T07:06:11.000000Z',
  },
  {
    id: 3,
    gym_name: 'Muscle Factory',
    email: null,
    contact_no: null,
    country: null,
    city: null,
    about_me: null,
    location: null,
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
    owner: {
      id: 4,
      name: 'Muhammad Shakeeb Hussain',
      first_name: 'Muhammad Shakeeb',
      last_name: 'Hussain',
      email: 'Shakeebmuhammad416@gmail.com',
      email_verified_at: '2024-10-09T10:14:55.000000Z',
      contact_no: null,
      country: null,
      city: null,
      about_me: null,
      location: null,
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
      user_social_links: [],
      status: 'active',
      deleted_at: null,
      created_at: '2024-10-09T10:14:32.000000Z',
      updated_at: '2024-10-09T10:14:55.000000Z',
    },
    offering_gym_services: [],
    user_social_links: [],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-09T10:14:32.000000Z',
    updated_at: '2024-10-09T10:14:32.000000Z',
  },
  {
    id: 2,
    gym_name: 'IRON MAN GYMMMMMMMMMM',
    email: null,
    contact_no: null,
    country: null,
    city: null,
    about_me: null,
    location: null,
    lat: null,
    lon: null,
    avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
    cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
    owner: {
      id: 3,
      name: 'Muhammad Hamza',
      first_name: 'Muhammad',
      last_name: 'Hamza',
      email: 'mhamzamidland@yopmail.commm',
      email_verified_at: null,
      contact_no: null,
      country: null,
      city: null,
      about_me: null,
      location: null,
      lat: null,
      lon: null,
      role: {
        id: 3,
        role_name: 'gym owner',
        status: 'active',
        created_at: '2024-10-08T02:13:41.000000Z',
        updated_at: '2024-10-08T02:13:41.000000Z',
        deleted_at: null,
      },
      avatar: 'https://fitquestapi.dotserviz.co/storage/user_media/avatar.png',
      cover: 'https://fitquestapi.dotserviz.co/storage/user_media/cover.jpg',
      user_social_links: [],
      status: 'pending',
      deleted_at: null,
      created_at: '2024-10-09T10:13:29.000000Z',
      updated_at: '2024-10-09T10:13:29.000000Z',
    },
    offering_gym_services: [],
    user_social_links: [],
    status: 'pending',
    deleted_at: null,
    created_at: '2024-10-09T10:13:29.000000Z',
    updated_at: '2024-10-09T10:13:29.000000Z',
  },
];
